import { makeStyles } from '@material-ui/core/styles';

export const makeParagraphStyles = makeStyles({
    h6: {
        fontSize: '1.05rem',
    }
}, { index: 1, });